import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import React from "react";
import Token from "../../assets/icon/token.png";
import { ListItemText } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { HeaderLandingPage } from "./header";
import { Footer } from "./footer";
const CounterToken = () => {
  return (
    <>
      <HeaderLandingPage />
      <Box bgcolor={"#ffceec"} py={2}>
        <Container>
          <Grid container alignItems={"center"}>
            <Grid item md={6}>
              <Box textAlign={"center"}>
                <Box width={"90px"} component={"img"} src={Token} alt="icon" />
                <Typography fontSize={"2.1em"} fontWeight={"500"}>
                  COUNTER TOKEN SYSTEM
                </Typography>
              </Box>
            </Grid>
            <Grid item md={6}>
              <Typography fontSize={"20px"}>
                Counter Sales & Token Generation Module is suitable for below
                business lines:
              </Typography>
              <Grid container>
                <Grid item md={6}>
                  <List>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Bakery
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Grocery Shops
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Beer Shops
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Ayurvedic Stores
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Juice Centers
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Snack Centers
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Patanjali Stores
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Exhibitions
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Food Trucks
                      </ListItemText>
                    </ListItem>
                  </List>
                </Grid>
                <Grid item md={6}>
                  <List>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Quick Service Restaurants
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Fast Food Outlets
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Dhaba
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Spas and Salons
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Individual or Chain of Stores
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Milk Bars
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Ice Cream Parlors
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      sx={{
                        padding: "0px",
                        "& .MuiTypography-root": { fontSize: "1.2em" },
                      }}
                    >
                      <ListItemText sx={{ margin: "0px" }}>
                        <CheckRoundedIcon sx={{ verticalAlign: "sub" }} />
                        Dairy Outlets
                      </ListItemText>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item md={6} pr={2}>
              <Typography
                padding={"30px 0px"}
                fontSize={"41px"}
                fontWeight={"bold"}
                color={"#2d3c58"}
                fontFamily={"Be Vietnam Pro"}
              >
                Features :
              </Typography>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Multi-device login
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  The same login can be used on another device.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Bill Amount with QR
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Every bill is printed with the amount and QR code for easy UPI
                  payment.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Inventory/stock
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Auto deduction of Inventory or Stock facility is available.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Assistant User
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Assistant user facility is available for staff members of
                  restaurants with restricted access.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Credit Bills & Outstanding Report
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Customers can receive their credit bills or outstanding
                  balance reports as well.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Online/Cash Bill Payment Report
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Segregate cash and online payment received, to tally counter
                  at day end.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  expence
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Record expence details to get the Profit Margin report.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Dashboard
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Daily/Weekly/Monthly status is available with a single click
                  through the dashboard utility.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Bill Sharing
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Restaurant owners can send bill details to the customer
                  through SMS & WhatsApp.
                </Typography>
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Various Reports
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Various reports can be downloaded in PDF and Excel formats
                </Typography>
              </Box>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Bill Discount
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  PBill discount feature is added for every bill.
                </Typography>
              </Box>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  GST Bills
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  BuGST Billing is optional (depending on the product).
                  Provision for monthly GST Billed report.
                </Typography>
              </Box>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Payment Receipts
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Payment Receipts can be printed/sent through SMS & WhatsApp.
                </Typography>
              </Box>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Section-wise Tables
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Tables are organized in different sections like AC Hall/Family
                  Hall/ Garden/Upper level, this helps in easily tracing the
                  table with its order. Availability of Multiple user access to
                  check the list of orders on a particular table and update it.
                </Typography>
              </Box>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Business profile
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Business profile is used for Payment Gateway Configuration .
                </Typography>
              </Box>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Item or Services
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Items can be added/deleted in the Item List and it can be
                  edited easily through this functionality.
                </Typography>
              </Box>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Item Categories
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Item list can be managed with the help of Item Categories.
                </Typography>
              </Box>
              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Supports Printer
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Provides support for thermal printers through both Bluetooth
                  and cable connections.
                </Typography>
              </Box>

              <Box py={1}>
                <Typography
                  fontFamily={"Be Vietnam Pro"}
                  fontSize={"20px"}
                  fontWeight={"600"}
                >
                  Supported Hardware
                </Typography>
                <Typography fontFamily={"Be Vietnam Pro"}>
                  Application works on Android Mobile/Tab/POS.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default CounterToken;
